/*
*###############################################################################
*Module Name                   : DPLoadingAlert.js                             #
*Purpose of the Module         :                                               #
*Description of the Module     :                                               #
*Original Author               :  Dinisuru Balasuriya                          #
*Date                          : Friday , November 2021, 10:10:27 am           #
*Copyright (c) 2021 myPOS Software Solution (pvt Ltd.)                         #
*###############################################################################
*/

import React, { useState } from 'react';
import { Row, Col } from "reactstrap"
//SweetAlert
import SweetAlert from "react-bootstrap-sweetalert"
import { BarWave, BouncingBalls, Messaging, CircularProgress } from "react-cssfx-loading";
import { Label } from 'recharts';
import { CustomLoader } from './Loader/CustomLoader';
const DPLoadingAlert = ({ confirm_both, title }) => {

    return (
        <div>
            {confirm_both ? (
                <SweetAlert
                    title={""}
                    disabled={true}
                    style={{ backgroundColor: "#000000", opacity: "0.8", background: "rgba(76, 175, 80, 0.0)", margin: "0px" }}
                    closeOnClickOutside={false}
                    onConfirm={() => {}}
                    customButtons={<React.Fragment>
                        <Row style={{ alignContent: "center" }}>
                            <Col sm="12" md="12" >
                                <div>
                                    <label >{title}</label>
                                </div>
                            </Col>

                            <Col sm="12" md="12" >
                                <div style={{ alignContent: "center" }}>
                                    <div style={{ width: "50px", marginLeft: "30%" }}>
                                        <BouncingBalls color="#F0F3F8" width="30px" height="15px" duration="400ms" />
                                        {/* <CustomLoader/> */}
                                    </div>
                                </div>
                            </Col>
                        </Row>

                    </React.Fragment>}
                >
                </SweetAlert>
            ) : null}
        </div>
    );
}
export default DPLoadingAlert;